import {CallJs} from "../../lib/types"
import {group, concatenate} from "../../lib/utils"
import * as ReactDOM from "react-dom";
import * as React from "react";

const stateInfo: StateInfo = {}
type StateInfoCallJs = {simplerName: string, fieldName: string, stateSelectList: string, stateInput: string, country: string, countryField:string}
type StateInfo = {[ix: string]: {stateSelectList: string, stateInput: string}}
export const initializeStateInfo: CallJs<StateInfoCallJs> = (callback, params) => {
	stateInfo[params.fieldName] = {stateSelectList: params.stateSelectList, stateInput: params.stateInput}
	updateState(params.fieldName)(params.country)
	//hopefully not needed, but it's contacts - who knows
	window[params.simplerName + "Update"] = updateState(params.fieldName)
	$(() => {
		const countries = document.getElementsByName(params.countryField)
		countries.forEach( c => c.onchange = function () {updateState(params.fieldName)((this as HTMLSelectElement).value)})
	})
}

declare global {
	interface Window {
		[ix: string]: any
	}
}

export const updateState = (stateFieldId: string) => (country: string) => {
	const rootDiv = document.getElementById(stateFieldId);
	if(!rootDiv) return
	const child = rootDiv.firstChild;
	if(!child) return

	if (!country || country == 'Australia' || country.length == 0)
	{
		if (child.nodeName != 'SELECT')
		{
			rootDiv.innerHTML = stateInfo[stateFieldId].stateSelectList
		}
	}
	else
	{
		rootDiv.innerHTML = stateInfo[stateFieldId].stateInput
	}
}

export const renderError: CallJs<{error_message: string}> = (callback, params) => {
	alert(params.error_message)
}

type EmailPlaceholder = {
	label: string
	isActive: boolean
}
type EmailPlaceholdersCallJs = {ClientOrAccess: EmailPlaceholder[], Info: EmailPlaceholder[]}

export const renderEmailPlaceholders: CallJs<EmailPlaceholdersCallJs> = (callback, params) => {
	const reactDiv = document.createElement('div')

	const res = []
	for(const placeholders of group(concatenate(params.ClientOrAccess, params.Info), 4)) {
		const eles = []
		for (const pl of placeholders) {
			if(pl === undefined) {
				eles.push(<td style={{textAlign: 'center'}}/>)
			} else {
				const label = `[${pl.label}]`
				const content = pl.isActive ? <span style={{color: "red"}}>{label}</span> : label
				eles.push(<td style={{textAlign: 'center'}}>{content}</td>)
			}
		}

		res.push(<tr>{eles}</tr>)
	}

	ReactDOM.render(
		<table cellPadding={0} cellSpacing={0} className="adminlist" style={{width: "100%"}}>
			<tr><td  colSpan={4}>
				<strong>The following placeholders can be added to the email</strong>{"\xa0\xa0\xa0"}
				(<span style={{color: 'red'}}>[PlaceHolders]</span> = Already In Message):
			</td></tr>
			{res}
		</table>, reactDiv)
	callback(reactDiv)
}

type PasswordCallJs = {name: string, minComplexity: number, minLength: number}
export const passwordField: CallJs<PasswordCallJs> = (callback, params) => {
	$(function () {
		var progressbar = $("#" + params.name + "-password-validation-progress" )
		if(!progressbar.progressbar) return
		var securityType = function( value: number ) {
			if ( value < 20 )
				return 'Very Weak'
			else if ( value < 40 )
				return 'Weak'
			else if( value < 60 )
				return 'Good'
			else if( value < 80 )
				return 'Strong'

			return 'Very Strong'
		}
		progressbar.progressbar()
		var progressbarValue = progressbar.find( '.ui-progressbar-value' )
		var progressLabel = progressbar.find( '.progress-label' )
		var passwordField = $("#" + params.name)
		passwordField.complexify({
			minComplexity: params.minComplexity,
			minimumChars: params.minLength,
			strengthScaleFactor: 0.5
	}, function (valid: boolean, complexity: number) {
			progressbar.progressbar( 'option', 'value', complexity)
			progressbarValue.css( { 'background': valid ? '#88bb88' : '#ffaaaa', border: '1px solid ' + (valid ? 'green' : 'red') } )
			progressLabel.text( securityType( complexity ) )
			passwordField.data( 'sb-invalid-message', valid ? null : 'The password is not valid' )
		})
	})
}


// WEBPACK FOOTER //
// ./src/contacts/contactPage/index.tsx